import { createFeedbackSubmissionSession } from '../../../utils/feedbackQueue/submission';
import { getIncompleteSurvey } from './incompleteSurveys';

const sessions = new WeakMap();

/** Reducer-owned context objects change on load/reset; promises stay outside Redux. */
export function getFlowSubmissionSession(flow, nodeId) {
  const context = flow.submissionContext || flow.initial || flow;

  if (!sessions.has(context)) {
    const saved = getIncompleteSurvey(nodeId, flow.id);
    sessions.set(
      context,
      createFeedbackSubmissionSession(context.submissionId, {
        feedbackId: saved?.feedbackId,
        version: saved?.version,
        ...context,
      }),
    );
  }

  return sessions.get(context);
}
